module.exports = __webpack_public_path__ + "media/10.a6a2e252.mp3";